import { useLocalStorage } from '@mantine/hooks';
import { STORAGE_KEYS } from 'consts';

import { setRefreshToken } from 'helpers';
import { useShowNotification } from 'hooks';
import { useTranslation } from 'react-i18next';

export const useSuccessLogin = () => {
  const { t } = useTranslation('user');
  const [, setToken] = useLocalStorage({
    key: STORAGE_KEYS.token,
    serialize: value => value,
    getInitialValueInEffect: false,
  });

  const showNotification = useShowNotification();

  return (accessToken: string) => {
    setToken(accessToken);
    setRefreshToken(accessToken);
    showNotification({
      message: t('signedInSuccessfully', { ns: 'user' }),
    });
  };
};
